import { useEffect } from 'react';

export function useDebouncedResize(callback: () => void, delay: number = 300): void {
	useEffect(() => {
		let timeoutId: number;

		const handleResize = () => {
			clearTimeout(timeoutId);
			timeoutId = window.setTimeout(() => {
				callback();
			}, delay);
		};

		// Tabs is utilizing this event listener to force image getting the correct size
		window.addEventListener('resize', handleResize);

		return () => {
			clearTimeout(timeoutId);
			window.removeEventListener('resize', handleResize);
		};
	}, [callback, delay]);
}
